import { useState, useEffect } from 'react';
import { getUserFiles } from '../../../shared/services/apiGateway';

function useUserFiles(userid = '') {
  const [userFiles, setUserFiles] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      const response = await getUserFiles(userid, null, abortController.signal);
      if (!ignore && response !== 'aborted' && response) {
        setUserFiles(response);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [userid]);

  return userFiles;
}

export default useUserFiles;
